import React, { useState, useEffect } from "react"
import MetaTags from 'react-meta-tags';
import { useSelector } from "react-redux";

import { Link, useHistory } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import moment from 'moment';
import { changeContractSettlement, contractDetailResponse, getCollectionSettlementList, postMyContract, tradeHistoryCall } from "../../crud/auth.crud"
import Util from "pages/Dashboard/Common/Util";

import loading from "../../assets/images/loading.gif";
import Modal from "components/RopikCustom/Modal";
import { getSummaryWasteCollectDataList, getSummaryWasteCollectDataListAll, getSummaryWasteCollectDataListThisMonth } from "crud/summary.crud";
import { getCollectDashboardData } from "crud/dashboard.crud";
import * as XLSX from 'xlsx';


const initSearchCondition = {
  companyName: '',
  companyNumber: '',
  businessNumber: '',
  cms: '',
  businessClassification: '',
  businessSize: '',
  settlementDate: '',
  car: '',
  collectionArea: '',
  bill: '',  
}

const initDashboardItem = [
  { text: '금월 총 정산 예정 금액', unit: '', value: 0 },
  { text: '금월 미납', unit: '', value: 0, viewMore: true, type: 'month' },
  { text: '총 미납금액', unit: '', value: 0 },
  { text: '총 미납', unit: '', value: 0, viewMore: true, type: 'total' },
]

const SettlementManagement = () => {

  const selector = useSelector(state => state)
  const history = useHistory()

  const [dataList, setDataList] = useState([]);
  const [companyId, setCompanyId] = useState(selector.auth?.user?.member_group?.[0]?.company_group.id)
  const [isLoading, setIsLoading] = useState(false);
  const [isListEnd, setIsListEnd] = useState(false);
  const [date, setDate] = useState(moment().format('YYYY-MM'));
  const [searchCondition, setSearchCondition] = useState(initSearchCondition)
  const [selectedCompany, setSelectedCompany] = useState('')
  const [dashboardItem, setDashboardItem] = useState(initDashboardItem)
  const [type, setType] = useState('all')
  const [listCount, setListCount] = useState(0)
  const [page, setPage] = useState(1)
  const [refresh, setRefresh] = useState(false)


  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY || document.documentElement.scrollTop
      const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight
      if (scrollPosition >= scrollHeight - 1 && !isLoading) {
        setPage(page + 1)
      }
    }
    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [dataList])

  const getTopDashBoardData = async () => {
    try {
      const response = await getCollectDashboardData();
      if (response.data?.result === 'success') {
        const item = response.data?.data
        const summaryList = [
          { text: '금월 총 정산 예정 금액', unit: '', value: Util.setCommaPrice(item.month_sum) },
          { text: '금월 미납', unit: '', value: Util.setCommaPrice(item.month_count), viewMore: true, type: 'month' },
          { text: '총 미납금액', unit: '', value: Util.setCommaPrice(item.total_sum) },
          { text: '총 미납', unit: '', value: Util.setCommaPrice(item.total_count), viewMore: true, type: 'total' },
        ]
        setDashboardItem(summaryList)
      }
      setRefresh(false)
    } catch (error) {
      console.error(error);
      setRefresh(false)
    }
  }

  const getDataList = async () => {
    try {
      if (isLoading || isListEnd) {
        return;
      }

      setIsLoading(true)
      const params = {
        page: page,
        company_name : searchCondition?.companyName || '',
        company_number : searchCondition?.companyNumber || '',
        summary_date : date || '',
        type : type
      }

      const rs = await getSummaryWasteCollectDataList(params);          
      if (rs.status === 200) {
        setListCount(rs.data.count)
        const content = rs.data?.results || [];
        const newList = [...dataList, ...content]
        if (page === 1) {
          setDataList(content)
        } else {
          setDataList(newList)
        }
        if (newList.length >= rs.data.count) {
          setIsListEnd(true)
        }
      }
      setIsLoading(false)
    } catch (e) {
      setIsLoading(false)
    }
  }

  const getDataListThisMonth = async () => {
    try {
      if (isLoading) {
        return;
      }

      setIsLoading(true)

      const rs = await getSummaryWasteCollectDataListThisMonth();
      if (rs.data.result === 'success') {
        setListCount(rs.data.data.length)
        setDataList(rs.data.data || [])
        setPage(1)
        setType('all')
        setDate(moment().format('YYYY-MM'))
        setSearchCondition(initSearchCondition)
      }
      setIsLoading(false)
    } catch (e) {
      setIsLoading(false)
    }
  }

  const getDataListAll = async () => {
    try {
      if (isLoading) {
        return;
      }

      setIsLoading(true)

      const rs = await getSummaryWasteCollectDataListAll();
      if (rs.data.result === 'success') {
        setListCount(rs.data.data.length)
        setDataList(rs.data.data || [])
        setPage(1)
        setType('all')
        setDate(moment().format('YYYY-MM'))
        setSearchCondition(initSearchCondition)
      }
      setIsLoading(false)
    } catch (e) {
      setIsLoading(false)
    }
  }

  const changeSearchCondition = (key, value) => {
    setSearchCondition(prev => ({ ...prev, [key]: value }))
  }

  const excelDownload = async () => {
    const table = document.getElementById('excel-table');
    if (!table) return;

    const rows = table.querySelectorAll('tr');
    const data = [];

    for (let i = 0; i < rows.length; i++) {
      const cells = rows[i].querySelectorAll('td, th');
      const rowData = [];

      for (let j = 0; j < cells.length; j++) {
        rowData.push(cells[j].innerText);
      }

      data.push(rowData);
    }

    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      type: 'array'
    });

    const blob = new Blob(
      [wbout],
      { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' }
    );

    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `${'거래처 정산 목록'}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  }

  const onSearch = async () => {
    if (page === 1) {
      setRefresh(true)
    } else {
      setPage(1)
    }
    setIsListEnd(false)
  }
  
  useEffect(() => {
    if (refresh)
      getDataList()
  }, [refresh])

  useEffect(() => {
    if (!isListEnd)
      setRefresh(true)
  }, [page, isListEnd])

  useEffect(() => {
    if (page === 1) {
      setRefresh(true)
    } else {
      setPage(1)
    }
    setIsListEnd(false)
    setIsLoading(false)
  }, [type, date])

  useEffect(() => {
    getTopDashBoardData()
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>거래처 정산관리 / 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs maintitle="Home" title="" breadcrumbItem="거래처 정산관리" />

          <div className="d-flex w-100 gap-30 align-items-center mb-3">
            <div className="email-rightbar flex-grow-1">
              <Card className="mb-0">
                <CardBody className="padding-0">
                  <table className="input-table">
                    <tbody>
                      <tr>
                        <td className="col-10 padding-left-8 primary-bg white-text font-size-12">상호검색</td>
                        <td className="col-20">
                          <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="사업자명을 입력하세요." value={searchCondition.companyName} onChange={(e) => {
                            changeSearchCondition('companyName', e.target.value)
                          }} />
                        </td>
                        <td className="col-10 padding-left-8 primary-bg white-text font-size-12">사업자번호 검색</td>
                        <td className="col-20">
                          <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="사업자번호를 입력하세요." value={searchCondition.companyNumber} onChange={(e) => {
                            changeSearchCondition('companyNumber', e.target.value)
                          }} />
                        </td>
                        <td className="col-10 padding-left-8 primary-bg white-text font-size-12"></td>
                        <td className="col-20"></td>
                      </tr>
                    </tbody>
                  </table>
                </CardBody>
              </Card>
            </div>
            <div className="d-flex flex-direction-column align-items-end">
              <button type="button" className="custom-btn btn-dark-gradient border-radius-0 white-text border-none margin-right-0" onClick={() => {
                onSearch()
              }}>
                검색
              </button>
            </div>
          </div>

          <Row>
            {dashboardItem.map((item, index) => (
              <Col xs={3} key={'settlement_management_dashboard_' + index}>
                <div style={{height: 105}} className="collect-history-box d-flex flex-direction-column">
                  <div className="d-flex justify-content-between w-100">
                    <p className="font-size-15 mb-0 line-height-1">{item.text}</p>
                    {item.viewMore &&
                      <p className="font-size-15 mb-0 pointer line-height-1" onClick={() => {
                        if (item.type === 'month') {
                          getDataListThisMonth()
                        } else {
                          getDataListAll()
                        }
                      }}>+ 더보기</p>
                    }
                  </div>
                  <div className="d-flex align-items-end justify-content-end flex-grow-1">
                    <p className="mb-0 font-size-50 font-weight-800 line-height-1">
                      {Util.setCommaPrice(item.value)}
                      <span className="font-size-18 font-weight-600"> {item.unit}</span>
                    </p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          <div className="d-flex justify-content-between align-items-center mb-2 margin-top-18">
            <div className="d-flex align-items-center">
              <select style={{width: 135}} className='waver-select-box border-radius-0 margin-right-4' value={type} onChange={(e) => {
                setType(e.target.value)
              }}>
                <option value="A">{'전체'}</option>
                <option value="N">{'미납'}</option>
              </select>
              <input style={{width: 135}} className="waver-input-box border-radius-0 margin-right-15" type="month" value={date} onChange={(e) => {
                setDate(e.target.value)
              }} />
              <p className="mb-0 font-size-16"><span className="font-weight-bold">거래처 정산 목록</span> [ 건수 : {listCount}건 ]</p>
            </div>
            <div className="waver-pagination-btn-group" >
              <button className="custom-btn success-bg border-radius-0 white-text border-none margin-right-0"
                onClick={() => {
                  excelDownload()
                }} >
                엑셀 다운로드
              </button>
            </div>
          </div>
          <Row>
            <Col xs="12">
              <div className="email-rightbar mb-3">
                <Card>
                  <CardBody style={{ padding: 0, borderRadius: 4, overflow: 'hidden' }}>
                    <div className="table-responsive">
                      <table id="excel-table" className="table table-hover table-centered table-nowrap mb-0 chart-table">
                        <thead className="chart-thead">
                          <tr>
                            <th scope="col">No</th>
                            <th scope="col">사업자 번호</th>
                            <th scope="col">상호</th>
                            <th scope="col">요금제</th>
                            <th scope="col">수거단위</th>
                            <th scope="col">단가</th>
                            <th scope="col">기본금액</th>
                            <th scope="col">기본량</th>
                            <th scope="col">수거량</th>
                            <th scope="col">정산금액(원)</th>
                            <th scope="col">정산일자</th>
                            <th scope="col">납부일자</th>
                            <th scope="col">결제수단</th>
                            <th scope="col">납부여부</th>
                          </tr>
                        </thead>
                        <tbody className="chart-tbody">
                          {dataList.length > 0 && dataList.map((item, index) => {
                            return (
                              <tr key={item.id + '_' + index}>
                                <td className="pointer" >{dataList.length - index}</td>
                                <td className="pointer" >{item.company?.company_number}</td>
                                <td className="pointer" onClick={()=>{history.push({ pathname: '/settlement-management-detail', state: { company: item.company, contract: item.contract } })}}>{item.company?.name || ''}</td>
                                <td className="pointer" >{item.contract?.billing_type == 'P' ? '종량제' : '정액제'}</td>
                                <td className="pointer" >{item.contract?.collect_type}</td>
                                <td className="pointer" >{Util.setCommaPrice((item.contract?.collect_type == 'l' ? item.contract?.price_per_l : item.contract?.price_per_kg_emitter) || 0) }</td>                                
                                <td className="pointer" >{Util.setCommaPrice(item.contract?.min_price|| 0)}</td>
                                <td className="pointer" >{Util.setCommaPrice((item.contract?.collect_type == 'l' ? item.contract?.min_l : item.contract?.min_kg) || 0)}</td>
                                <td className="pointer" >{Util.setCommaPrice((item.contract?.collect_type == 'l' ? item.contract?.qty_l : item.contract?.qty_kg) || 0)}</td>
                                <td className="pointer" >{Util.setCommaPrice(item.total_price || 0)}</td>
                                <td className="pointer" >{moment(item.summary_date).format('YYYY-MM-DD') || ''}</td>
                                <td className="pointer" >{item.payment_date ? moment(item.payment_date).format('YYYY-MM-DD') : ''}</td>
                                <td className="pointer" >{item.payment_type}</td>
                                <td
                                  className="pointer"
                                  style={{ color: item.state === 'Y' ? 'blue' : 'red' }}
                                >
                                   {item.state === 'Y' ? '완납' : item.state === 'N' ? '미납' : '부분납부'}
                                </td>
                              </tr>
                            )
                          })}
                          {dataList.length === 0 &&
                            <tr>
                              <td scope="row" colSpan="14">데이터가 없습니다.</td>
                            </tr>
                          }

                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                  {isLoading && <div style={{
                    position: "absolute",
                    width: '100%',
                    height: '100%',
                    top: 0,
                    left: 0,
                    background: 'rgba(255, 255, 255, 0.6)',
                    zIndex: 999,
                    display: "flex",
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <img src={loading} alt="로딩중입니다." width={'3%'}></img>
                  </div>}
                </Card>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default SettlementManagement
